export default {
  edgeComputingSection: {
    intro: {
      fr: "Le Edge Computing ",
      en: "Edge Computing ",
    },
    title: {
      fr: "au service d’une GTB simple et robuste",
      en: "built for simple and resilient BMS",
    },
    subtitle: {
      fr: "Evolutif, interopérable et pensé pour durer.",
      en: "Scalable, interoperable, and built to last.",
    },
    description: {
      fr: "Le Edge Computing place la puissance de traitement au plus près des équipements. Grâce à sa capacité de calcul avancée, il peut piloter un grand nombre d’équipements et orchestrer régulations, scénarios et automatismes à l’échelle d’un bâtiment. Résultat : une architecture GTB rationalisée, limitant le recours à de multiples automates terrain, plus simple à déployer, plus fiable et pleinement opérationnelle même sans Internet.",
      en: "Edge computing brings processing power closer to the equipment. With its advanced computing capabilities, it can manage large-scale IoT networks and run control loops, scenarios and automation logic across entire buildings. The result: a streamlined BMS architecture, reducing the need for multiple field controllers, easier to deploy, more reliable, and fully operational even without Internet connectivity.",
    },
    features: {
      feature1: {
        title: {
          fr: "GTB opérationnelle sans Internet",
          en: "A BMS that runs offline",
        },
        description: {
          fr: "Indépendant du cloud, votre Edge Computer assure la supervision et les automatismes en local, même sans connexion Internet. Aucun mode dégradé : 100 % des fonctionnalités restent disponibles, y compris l’historisation.",
          en: "Independent from the cloud, your Edge Computer keeps monitoring and automation fully operational on-site, even without Internet connectivity. No degraded mode, 100% of features remain available, including data logging.",
        },
      },
      feature2: {
        title: {
          fr: "Automatismes GTB en local (zéro latence)",
          en: "On-site automation, zero latency",
        },
        description: {
          fr: "Régulations, calendriers, scénarios et règles métiers s’exécutent sur site pour piloter les équipements au plus près des usages. Cette approche offre une fiabilité et une réactivité d'éxécution sans précédent.",
          en: "Control loops, schedules, scenarios and business rules run directly on site to manage equipment as close as possible to real-world usage. This approach delivers unmatched reliability and execution responsiveness.",
        },
      },
      feature3: {
        title: {
          fr: "Jusqu’à 200 équipements IoT par Edge",
          en: "Up to 200 IoT devices per Edge",
        },
        description: {
          fr: "Un réseau IoT maillé à grande échelle pour connecter actionneurs, capteurs et répéteurs, avec une architecture simple à mettre en oeuvre et à maintenir.",
          en: "A large-scale mesh IoT network connecting actuators, sensors and repeaters. Designed for fast rollout and easy on-site maintenance.",
        },
      },
      feature4: {
        title: {
          fr: "Mises à jour en continu",
          en: "Continuous software updates",
        },
        description: {
          fr: "Déployez de nouvelles fonctions et améliorations sans interrompre l’exploitation : la GTB reste disponible pendant les mises à jour.",
          en: "Ship new capabilities without disrupting operations—your BMS stays available during updates.",
        },
      },
      feature5: {
        title: {
          fr: "Interopérable GTB (multi-protocoles)",
          en: "BMS interoperability (multi-protocol)",
        },
        description: {
          fr: "Connexion aux équipements via les standards du bâtiment : Modbus, Zigbee… pour intégrer facilement CVC, éclairage, comptage et autres lots techniques.",
          en: "Connect to building systems through common standards: Modbus, Zigbee… making it easy to integrate HVAC, lighting, metering and other technical systems.",
        },
      },
      feature6: {
        title: {
          fr: "Résilience : le système ne s’arrête jamais",
          en: "Resilience by design",
        },
        description: {
          fr: "Connectivités et alimentations redondantes pour assurer la continuité d'accès à distance : Ethernet & 4G/Wi-Fi, 230V & batterie USB-C.",
          en: "Redundant connectivity and power for continuous remote access: Ethernet and 4G/Wi-Fi, plus dual power sources—230V and USB-C battery.",
        },
      },
    },
  },
};
